// Ported from native/src/editor/activity/plugins/challenge/BugBandFlow.js:216-224.
// Phase-machine activity: success = terminal state in runTrace OR phaseFlags.completed.

'use strict';

const {reachedTerminalState, totalBlockCount} = require('./helpers');

function evaluate (activityData, simState) {
    const phaseFlags = (simState && simState.phaseFlags) || {};
    return {
        success: reachedTerminalState(simState),
        usedBlocks: totalBlockCount(simState),
        storyPhase: phaseFlags.storyPhase || null,
        flagTapCount: phaseFlags.flagTapCount || 0,
        debugAttempts: phaseFlags.debugAttempts || 0
    };
}

module.exports = evaluate;
